export default __webpack_public_path__ + "static/media/li.249e148d.svg";